export const DEFAULT_PROJECT_IMAGE =
    'https://wcs.smartdraw.com/working-smarter/img/selecting-the-right-software-development-tools.png?bn=15100111845';
